// extracted by mini-css-extract-plugin
module.exports = {"tagTokens":"tag_tagTokens__HfH6w","onDark":"tag_onDark__q1Fpa","small":"tag_small__GqdNl","medium":"tag_medium__8AeaI","large":"tag_large___YzlE"};